/* eslint-disable  */
import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://192.168.100.72:8000/api/v1",
  // baseURL: "http://localhost:8000/api/v1",
  baseURL: "https://api.upnmg.com/api/v1",
  timeout: 1500000,
});

function getDeviceId() {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
}

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.common["Accept"] = "application/json";
    if (!(config.data instanceof FormData)) {
      config.headers.common["Content-Type"] = "application/json";
    }
    const token = window.localStorage.getItem("token");
    if (token !== null && token !== undefined) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    config.headers.common["x-device-id"] = getDeviceId();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response) {
      if (error?.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== "/") {
          // window.location.href = "/"
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
